import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface CheckoutWizardSettingsState {
    productList: string /** Son los bonos que tenemos que comprar para pedir cita de este servicio */;
    urlCheckout: string;
}

export function createInitialState(): CheckoutWizardSettingsState {
    return {
        productList: '',
        urlCheckout: '',
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'checkout-wizard-settings', resettable: true })
export class CheckoutWizardSettingsStore extends Store<CheckoutWizardSettingsState> {
    constructor() {
        super(createInitialState());
    }
}
